import root from 'window-or-global';
import React from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';
import { Row, Columns } from 'views/Grid';
import Rupee from 'views/Rupee';
import decorateSocialPay from '../decorators/SocialPay';
import scrollController from '../decorators/ScrollController';
import { getCookie } from 'config/utils';
import { getVariantCategoryName, range } from '../utils/InitializePurchaseUtils';
import { TOTAL_AMOUNT_CAN_CHANGE } from '../constants/GlobalConstants';
import classNames from 'classnames';
import StatefulSubmitButton from 'views/StatefulSubmitButton';
import {
  handleChangeInput,
  showDiscountCodeBox,
  handleApplyDiscount,
  handleRemoveDiscount,
  handleSubmitInitializePurchase,
  handleSetTotalAmount,
  handleSetSocialPayPlatformAndSubmitForm,
  getShippingCharges,
  applyBoost,
} from '../actions/InitializePurchaseActions';

import {
  handleSetupCloseSocialPayAuthWindowBeforeAuthListener,
} from '../actions/SocialPayActions';

import {
  Form,
  FormFieldWithLabel as FormField,
  FormFieldWrapper as FormFieldsWrapper,
  FormFieldLabel,
  InputCheckbox,
  InputNumber,
} from 'views/FormComponents';
import {
  FullName, Phone, Email,
} from './initialize';


export const Variants = ({ variantCategories, form, onChangeInput }) => {
  if (!variantCategories) {
    return null;
  }

  const { errors } = form;

  return (
    <div> {
      variantCategories.map(variantCategory => {
        const variantFieldName = getVariantCategoryName(variantCategory.id);
        return (
          <FormField
            key={variantCategory.id}
            label={variantCategory.name}
            errors={errors[variantFieldName] || errors.Variant}
            >
            <select
              onChange={e => onChangeInput({
                [variantFieldName]: e.target.value,
              })}
              value={form[variantFieldName]}
              >
              <option value="">Select an Option</option>
              {variantCategory.variants.map(variant =>
                <option value={variant.id} key={variant.id}>
                  {variant.title}
                </option>
              )}
            </select>
          </FormField>
        );
      })
    } </div>
  );
};

export const Quantity = ({
  isQuantityApplicable, quantity, errors, maxQuantity, onChangeInput,
}) => {
  if (!isQuantityApplicable) {
    return null;
  }

  return (
    <FormField label="Quantity" errors={errors.quantity}>
      <select
        value={quantity}
        onChange={e =>
          onChangeInput({
            quantity: e.target.value,
          })
        }>
        {range(maxQuantity).map(qty =>
          <option key={qty} value={qty}>{qty}</option>
        )}
      </select>
    </FormField>
  );
};

export const PayWhatYouWant = ({
  priceBoost, basePrice, form, onUpdate, onChangeInput, shippingCharges,
}) => {
  if (!priceBoost) {
    return null;
  }
  /**
   * if basePrice === 0
   * 	then show an option to "claim for free"
   */
  const {
    amount,
    errors,
    isClaimFreeChecked,
    isAmountEditable,
    readOnly,
    isPriceBoostApplied,
    priceBoostAmount,
  } = form;

  return (
    <FormField className="hard--bottom">
      <FormFieldsWrapper>
        <FormField
          label={readOnly.amount ?
            'Amount' :
            `Enter Amount (min Rs.${basePrice})`
          }
          errors={errors.amount}
          >

          { readOnly.amount ?
            <p className="flush"><Rupee value={amount} /></p> :

            <Row className="collapse prefix-radius postfix-radius">
              <Columns className="small-1">
                <span className="prefix"><Rupee /></span>
              </Columns>
              <Columns className="small-8">
                <InputNumber
                  style={{ borderRight:'none' }}
                  value={priceBoostAmount}
                  min={basePrice}
                  onFocus={e => e.target.select()}
                  onClick={e => e.target.select()}
                  onChange={e => onChangeInput({
                    priceBoostAmount: e.target.value,
                  })}
                  disabled={!isAmountEditable || isPriceBoostApplied}
                  data-disabled={true}
                  />
              </Columns>
              <Columns className="small-3">
              {
                (!isPriceBoostApplied)
                  ?
                    <div
                      className={ classNames('postfix', (!isAmountEditable || isPriceBoostApplied || !priceBoostAmount) ? 'text-light-grey' : 'text-blue') }
                      style={{ lineHeight:'0', marginLeft: '-1px' }}
                    >
                      <input
                        type="button"
                        onClick={() => onUpdate(true)}
                        disabled={!isAmountEditable || isPriceBoostApplied || !priceBoostAmount}
                        data-disabled={true}
                        value="UPDATE"
                        style={{ height:'100%', width:'100%', border:'none' }}
                        min={basePrice}
                      />
                     </div>
                  :
                    <div
                      className='postfix text-red'
                      style={{ lineHeight:'0', marginLeft: '-1px' }}
                    >
                      <input
                        type="button"
                        onClick={() => onUpdate(false)}
                        data-disabled={true}
                        disabled={!isAmountEditable}
                        value="CHANGE"
                        style={{ height:'100%', width:'100%', border:'none' }}
                      />
                    </div>
              }
              </Columns>
            </Row>
          }
        </FormField>

        { basePrice === 0 && !readOnly.amount && !shippingCharges ?
          <FormField>
            <InputCheckbox
              label="Claim this for Free"
              checked={isClaimFreeChecked}
              value={isClaimFreeChecked}
              disabled={ amount > 0 }
              data-disabled={true}
              onChange={e =>
                onChangeInput({
                  isClaimFreeChecked: e.target.checked,
                }
              )}
            />
          </FormField> :
          null
        }
      </FormFieldsWrapper>
    </FormField>
  );

};

class InitializePurchase extends React.Component {
  onChangeInput ( changedData, totalAmountCanChange ) {
    this.props.handleChangeInput(changedData, totalAmountCanChange);
  }

  componentDidUpdate () {
    const { isLinkPayment, isInstapayPayment } = this.props.initializePurchase;

    if (isLinkPayment || isInstapayPayment) {
      return;
    }

    const { form: { claimUrl, selectedSocialPayPlatform }, isFormServerValidated }
      = this.props.initializePurchase;

    const serverForm = this.serverForm;
    if (isFormServerValidated && claimUrl && serverForm) {
      serverForm.submit();
    }

    const { loading } = this.props.socialPay;
    if (isFormServerValidated && selectedSocialPayPlatform && serverForm && !loading[selectedSocialPayPlatform]) {
      // submitSocialPay comes from the decorated socialPay component
      this.props.submitSocialPay(selectedSocialPayPlatform, serverForm);
      this.props.handleSetupCloseSocialPayAuthWindowBeforeAuthListener(selectedSocialPayPlatform);
    }
  }

  componentWillReceiveProps (nextProps) {
    if (this.props.initializePurchase.totalAmount !== nextProps.initializePurchase.totalAmount) {
      try {
        const ref = ReactDOM.findDOMNode(this.refs.youPayText);
        ref.className = 'animated fade-in-down';
        setTimeout(() => {
          ref.className = '';
        }, 1000);
      } catch (e) {}
    }
  }

  componentDidMount () {
    const {
      shippingCharges,
    } = this.props.initializePurchase;
    if (this.props.offerDetails && root.INITIAL_STATE.offer && root.INITIAL_STATE.offer.type === 'physical' && root.INITIAL_STATE.is_shipping_charges_enabled && !shippingCharges) {
      this.props.getShippingCharges();
    }
    setTimeout(() => {
      try {
        ReactDOM.findDOMNode(this.refs.userForm).querySelector('input').focus();
      } catch (e) {}
    }, 0);
  }

  renderShippingCharges() {
    const {
      shippingCharges,
    } = this.props.initializePurchase;
    return(
      <div className='text-grey push--bottom' style={ { fontSize:'12px' } }> Shipping Charges: <Rupee value={shippingCharges}/></div>
    );
  }

  renderDiscount () {
    const {
      form: { isDiscountBeingEdited, discountCode, isDiscountEditable,
        errors, isDiscountApplied,
      },
    } = this.props.initializePurchase;
    const postfixClassNames = 'postfix flush';

    return (
      isDiscountBeingEdited ?
        <FormField errors={errors.discountCode}>
          <FormFieldLabel
            className={classNames('transition-color', { 'text-green': isDiscountApplied })}>
            {isDiscountApplied ?  'Discount Applied' : 'Discount Code'}
          </FormFieldLabel>
          <Row className="collapse postfix-radius">
            <Columns className="small-9">
              <input type="text"
                value={discountCode}
                disabled={!isDiscountEditable}
                onChange={e => this.onChangeInput({ discountCode: e.target.value })}
                />
            </Columns>
            <Columns className="small-3">
              {
                !isDiscountApplied ?
                <a className={classNames(postfixClassNames, 'text-blue')}
                  onClick={() => this.props.handleApplyDiscount()}>
                  Apply</a>
                :
                <a className={classNames(postfixClassNames, 'text-red')}
                  onClick={() => this.props.handleRemoveDiscount()}>
                  Remove</a>
              }
            </Columns>
          </Row>
        </FormField>
        :
        <p className="push--bottom">
          <a className="text-underline" onClick={() => this.props.showDiscountCodeBox()}>I have a Discount Code</a>
        </p>
    );
  }

  renderSubmitButton () {
    const { totalAmount, offer: {
      hasAdditionalInfoTab, socialpayPlatforms, minPrice,
    } } = this.props.initializePurchase;

    if (!totalAmount && socialpayPlatforms && !hasAdditionalInfoTab) {
      return this.props.renderSocialPayButtons(this.props.initializePurchase);
    }

    const buttonLabel = totalAmount || hasAdditionalInfoTab ?
      'Next' :
      minPrice && totalAmount ?
        <span>Min <Rupee value={minPrice} /></span> :
        'Claim for Free';

    return (
      <FormField>
        <StatefulSubmitButton value={buttonLabel} />
      </FormField>
    );
  }

  renderYouPay () {
    const {
      initializePurchase: {
        totalAmount,
      },
      totalAmountFormatted,
      showConvenienceFee,
     } = this.props;

    return (
      <li>
        <div style={{ borderTop: '1px solid #F0F4F8', borderBottom: '1px solid #F0F4F8' }}>
          <div className="soft-half--ends">
            <div ref="youPayText">
              { !showConvenienceFee ?
                <div className="center">
                  <span>You Pay </span>
                  <Rupee value={totalAmountFormatted} />
                </div> :
                <div>
                  <span>Amount</span>
                  <span className="right">
                    <Rupee value={totalAmountFormatted} />
                  </span>
                </div>
              }
            </div>
          </div>
        </div>
      </li>
    );
  }

  renderUserForm () {
    const {
      form,
      offer,
      form: { name, email, phone, readOnly, isDiscountApplicable, isQuantityApplicable, errors },
      offer: { minPrice, variantCategories, priceBoost },
      shippingCharges,
    } = this.props.initializePurchase;

    return (
      <Form id="userFormId" ref="userForm"
        errors={errors.All_}
        onSubmit={e => {
          e.preventDefault();
          this.props.handleSubmitInitializePurchase();
        }}
        >
        <FormFieldsWrapper>

          {/* Buyer's Full Name */}
          <FullName
            name={name}
            errors={errors}
            readOnly={readOnly}
            onChange={payload => this.props.handleChangeInput(payload)}
          />

          {/* Buyer's Email ID */}
          <Email
            email={email}
            errors={errors}
            readOnly={readOnly}
            onChange={payload => this.props.handleChangeInput(payload)}
          />

          {/* Buyer's Phone Number */}
          <Phone
            phone={phone}
            isInternationalNumberEnabled={this.props.isInternationalNumberEnabled}
            readOnly={readOnly}
            errors={errors}
            onChange={payload => this.props.handleChangeInput(payload)}
          />

          {/* Variant Categories */}
          <Variants
            variantCategories={variantCategories}
            form={form}
            onChangeInput={payload =>
              this.props.handleChangeInput(payload, TOTAL_AMOUNT_CAN_CHANGE)
            }
          />

          {/* Quantity Field */}
          <Quantity
            isQuantityApplicable={isQuantityApplicable}
            quantity={form.quantity}
            errors={form.errors}
            maxQuantity={offer.maxQuantity}
            onChangeInput={payload =>
              this.props.handleChangeInput(payload, TOTAL_AMOUNT_CAN_CHANGE)
            }
          />


          {/* Pay What You Want Amount Box */}
          <PayWhatYouWant
            priceBoost={priceBoost}
            basePrice={offer.basePrice}
            shippingCharges={shippingCharges}
            form={form}
            //This is to change the button status on click
            onUpdate={ (status) =>
               this.props.applyBoost(status)
             }
             //This is to change the price boost amount.
            onChangeInput={payload =>
              this.props.handleChangeInput(payload)
            }
          />

          {/* Discount Code needs to be enabled per offer. So is not always available */}
          { isDiscountApplicable && minPrice ?
            this.renderDiscount() :
            null
          }

          { (this.props.offerDetails && root.INITIAL_STATE.offer && root.INITIAL_STATE.offer.type === 'physical' && root.INITIAL_STATE.is_shipping_charges_enabled)
            ? this.renderShippingCharges()
            : null
          }

          {this.renderYouPay()}

          {/* Submit Button */}
          {this.renderSubmitButton()}

        </FormFieldsWrapper>
      </Form>
    );
  }

  renderHiddenServerForm () {
    const {
      form: { claimUrl, socialpayUrl, selectedSocialPayPlatform },
    } = this.props.initializePurchase;
    return (
      <form ref={(ref) => this.serverForm = ref} action={!selectedSocialPayPlatform ? claimUrl : socialpayUrl} method="POST">
        <input type="hidden" name="csrfmiddlewaretoken" value={getCookie('csrftoken')} />
      </form>
    );
  }

  render () {
    const { form: { claimUrl, socialpayUrl }, isFormServerValidated } = this.props.initializePurchase;
    return (
      <div>
        {this.renderUserForm()}
        {(claimUrl || socialpayUrl) && isFormServerValidated ? this.renderHiddenServerForm() : null}
      </div>
    );
  }
}

InitializePurchase.propTypes = {
  isOpenable: PropTypes.bool.isRequired,
  isOpen: PropTypes.bool.isRequired,
};

InitializePurchase.defaultProps = {
  isOpenable: true,
  isOpen: true,
  isAnimated: false,
};

function mapStateToProps (state) {
  const {
    initializePurchase,
    socialPay,
    settings: {
      isMobileDevice,
      showConvenienceFee,
      isInternationalNumberEnabled,
    },
    finalizePurchase: { totalAmountFormatted },
    offerDetails,
  } = state;

  return {
    initializePurchase,
    socialPay,
    isMobileDevice,
    showConvenienceFee,
    isInternationalNumberEnabled,
    totalAmountFormatted,
    offerDetails,
  };
}

export default connect(mapStateToProps, {
  handleChangeInput,
  showDiscountCodeBox,
  handleApplyDiscount,
  handleRemoveDiscount,
  handleSubmitInitializePurchase,
  handleSetTotalAmount,
  handleSetSocialPayPlatformAndSubmitForm,
  handleSetupCloseSocialPayAuthWindowBeforeAuthListener,
  getShippingCharges,
  applyBoost,
})(scrollController(decorateSocialPay(InitializePurchase)));



// WEBPACK FOOTER //
// ./src/payments/views/InitializePurchase.js